module.exports = __webpack_public_path__ + "static/media/pin.812a5782.png";